// Legacy polyfills removed - native browser support
import { REV } from 'common/magicGlobals';
import { errorHandlingInit } from 'common/error_handling';

window.REV = REV;
window.SHORT_REV = window.REV.substring(0, 7);

window.isDev = function() {
  return window['env'] === 'development' || false;
};
window.isWyIP = function() {
  return window.current_user && window.current_user.isWyIp || false; // SESSION
};
window.isHot = function() {
  return window['env'] === 'development' && window.location.port !== '3000' || false;
};
window.isProd = function() {
  return window['env'] !== 'development';
};

window.loadTime = -1;
window.addEventListener('load', function() {
  var timing = window.performance && window.performance.timing;
  if (timing && timing.navigationStart) {
    window.loadTime = ((timing.domContentLoadedEventEnd - timing.navigationStart) / 1000) || -1;
    console.log('Page ready in ' + window.loadTime + ' seconds');
  }
  else {
    console.log('Browser does not support `window.performance`');
  }
}, false);

function itemFormatSelection(item) {
  return item.sku + ' - ' + item.name;
}

let prepend_locale = '/en-US';
let url_str = document.URL;
if (url_str.indexOf('/en-CA') !== -1) {
  prepend_locale = '/en-CA';
}

export function coreInit(initREV) {
  const $ = setJq();
  window.setJq = setJq;

  window.$.cookie = () => {
    console.warn('Ok, here is a cookie 🍪, stop asking.');
    return true;
  };

  // Re-initialize error handling (refreshes window.appsignal and window.ErrorReporter)
  errorHandlingInit(window.RMTREV || REV);

  // Don't rely on implicit globals
  window.prepend_locale = prepend_locale;
  window.url_str = url_str;
  window.itemFormatSelection = itemFormatSelection;

  // Shims
  function jQueryDeprecationNotice() {
    console.warn('Call is deprecated', this);
    return this;
  }

  if (window.handleGDPR) {
    window.handleGDPR();
    window.handleGDPR = null;
  }

  /**
   * Sets the html of the given element to a loading spinner
   * @param selector
   */
  window.setToLoadingHtml = selector => window.$(selector).html('<div class="loading-container">\n  <div class="loading"></div>\n  <div id="loading-text">loading</div>\n</div>\n');

  window.jQuery.fn.blockUI = jQueryDeprecationNotice;
  window.jQuery.fn.unblockUI = jQueryDeprecationNotice;

  window.constructEcommObject = addedProducts => ({
    contents: addedProducts,
    content_ids: addedProducts.map(({ id }) => id),
    content_type: 'product',
    num_items: addedProducts.reduce((acc, { quantity }) => acc + parseFloat(quantity), 0),
    currency: window.localeCountry === 'ca' ? 'CAD' : 'USD',
    value: addedProducts.reduce(
      (acc, { price, quantity }) => acc + parseFloat(price) * parseFloat(quantity),
      0
    )
  });

  window.notieQueue = [];
  if (window.notice_queue)
    window.notieQueue.push({
      text: window.notice_queue,
      time: 10,
      position: 'top'
    });
  if (window.warning_queue)
    window.notieQueue.push({
      type: 'warning',
      text: window.warning_queue,
      time: 10,
      position: 'top'
    });
  if (window.error_queue)
    window.notieQueue.push({
      type: 3,
      text: window.error_queue,
      position: 'top',
      stay: true
    });

  console.log(
    `[core.js] loaded revision{${window.RMTREV && window.RMTREV.substring(0, 7)}|${REV.substring(
      0,
      7
    )}} in ${window.env}`,
    window.current_user
  );
  window.notieQueue = window.notieQueue || [];
  window.drainNotieQueue(window.notieQueue, window.$, window.appsignal);

  window.errorQueue = window.errorQueue || [];
  window.drainErrorQueue(window.errorQueue, window.$, window.appsignal);
}

export function getErrorReporter() {
  return window.ErrorReporter;
}

export function getJq() {
  return window.$ || require('jquery');
}

export function setJq() {
  window.$ = getJq();
  window.jQuery = window.jQuery || getJq();
  return window.$;
}

coreInit(REV);

// console.log(window.current_user, window.pageCsrf);
window.csrf = window.pageCsrf && window.pageCsrf.token || window.$('meta[name=csrf-token]').attr('content');
let csrf = window.csrf;

export { prepend_locale, url_str, itemFormatSelection, csrf, REV };
